import { useParams } from "react-router-dom";

import CustomerTabs from "@/components/CustomerTabs";
import DataLoader from "@/components/DataLoader";
import { OrderDetailsContent, OrderNotFound } from "@/components/orders/OrderDetailPage";
import OrderDetailTemplate from "@/components/orders/OrderDetailTemplate";
import B2CHeader from "@/tpo/header/B2CHeader";

import { ORDER_QUERY } from "./graphql";

export default function OrderDetailPage() {
  const { id } = useParams();

  return (
    <>
      <B2CHeader />
      <DataLoader
        query={ORDER_QUERY}
        variables={{
          id
        }}
        render={({ order }) => (
          <>
            {order ? (
              <OrderDetailTemplate tabs={<CustomerTabs />} title="Order Detail" gap={0}>
                <OrderDetailsContent {...order} order={order} />
              </OrderDetailTemplate>
            ) : (
              <OrderNotFound tabs={<CustomerTabs />} />
            )}
          </>
        )}
      />
    </>
  );
}
